import { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";

export function useDateInputs(daysSorted, mode) {
  const initRef = useRef({ mode: null });

  const [startDateInput, setStartDateInput] = useState("");
  const [endDateInput, setEndDateInput] = useState("");

  useEffect(() => {
    if (!Array.isArray(daysSorted) || daysSorted.length === 0) return;

    // 🔑 reset initialization ONLY when mode changes
    if (initRef.current.mode !== mode) {
      initRef.current.mode = mode;

      const [d, m, y] = daysSorted[daysSorted.length - 1]
        .split("-")
        .map(Number);

      const latest = dayjs(new Date(y, m - 1, d));
      
      // Use today (latest) as default for all modes
      const defaultDate = latest;
      
      const end = defaultDate.format("YYYY-MM-DD");

      setEndDateInput(end);

      if (mode === "minute" || mode === "epg") {
        setStartDateInput(end);
      } else {
        setStartDateInput(defaultDate.subtract(7, "day").format("YYYY-MM-DD"));
      }
    }
  }, [daysSorted, mode]);

  return {
    startDateInput,
    setStartDateInput,
    endDateInput,
    setEndDateInput,
  };
}
